import React from 'react';
import { Divider, Header, Segment } from 'semantic-ui-react';

import InfoPlanesDePago from './InfoPlanesDePago';
import TablaAlumnosDeApoderado from './TablaAlumnosDeApoderado';
import TablaCobrosCalculados from './TablaCobrosCalculados';
import TablaPagosCuota from './TablaPagosCuota';
import { PlanDePago } from './tipos';

interface Props extends PlanDePago {
    nombreCompletoApoderado: string;
    rutPasaporte: string;
    alRealizarPago(): void;
    alEditarPago(): void;
}

const PlanesDePago: React.FunctionComponent<Props> = props => {
    const {
        idPlanDePago,
        formaDePago,
        numeroDePagare,
        fechaDePrimerPago,
        diaDePago,
        numeroDeCuotas,
        valorPorCuota,
        fechaDeMatricula,
        estado,
        alumnos,
        sumaDeLosContratos,
        valorDelPagare,
        cobrosCalculados,
        cuotas,
        observacionesFinancieras,
        nombreCompletoApoderado,
        rutPasaporte,
        aNombreDeAsesor,
        sede,
    } = props;
    return (
        <div>
            <Segment attached='top'>
                <Header as='h2'>Plan de pago vigente</Header>
            </Segment>
            <Segment attached='bottom'>
                <InfoPlanesDePago
                    idPlanDePago={idPlanDePago}
                    estado={estado}
                    formaDePago={formaDePago}
                    numeroDePagare={numeroDePagare}
                    valorDelPagare={valorDelPagare}
                    fechaPrimeraCuota={fechaDePrimerPago}
                    diaDePago={diaDePago}
                    numeroDeCuotas={numeroDeCuotas}
                    valorPorCuota={valorPorCuota}
                    // TODO El monto total ya no debería existir
                    sumaDeLosContratos={sumaDeLosContratos}
                    fechaDeMatricula={fechaDeMatricula}
                    observacionesFinancieras={observacionesFinancieras}
                    aNombreDeAsesor={aNombreDeAsesor}
                    sede={sede}
                />
                <Divider />
                <TablaAlumnosDeApoderado alumnos={alumnos} />
                <Divider section />
                <TablaPagosCuota
                    idPlanDePago={idPlanDePago}
                    cuotas={cuotas}
                    nombreCompletoApoderado={nombreCompletoApoderado}
                    rutPasaporte={rutPasaporte}
                    alRealizarPago={props.alRealizarPago}
                    alEditarPago={props.alRealizarPago}
                />
                <Divider />
                {cobrosCalculados.length > 0 && (
                    <TablaCobrosCalculados
                        idPlanDePago={idPlanDePago}
                        cobrosCalculados={cobrosCalculados}
                        nombreCompletoApoderado={nombreCompletoApoderado}
                        rutPasaporte={rutPasaporte}
                        alRealizarPago={props.alRealizarPago}
                        alEditarPago={props.alRealizarPago}
                        fechaDeMatricula={fechaDeMatricula}
                    />
                )}
            </Segment>
        </div>
    );
};

export default PlanesDePago;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/PlanesDePago.tsx